import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEO from '@/components/feature/SEO';
import Hero from './components/Hero';
import PolicyTimeline from './components/PolicyTimeline';
import Doc414 from './components/Doc414';
import FormulaIP from './components/FormulaIP';

export default function Strategy() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <SEO
        title="国家战略 | 414号文 · 人工智能应用服务商政策解读"
        description="解读乡村振兴、数字乡村、县域商业与数据要素四大国家战略，重点展示工信厅科函414号文与人工智能应用服务商方向。"
        keywords="国家战略,414号文,人工智能应用服务商,乡村振兴,数字乡村"
        path="/strategy"
        jsonLd={{
          '@context': 'https://schema.org',
          '@type': 'Article',
          headline: '国家战略 · 414号文 · 人工智能应用服务商政策解读',
          about: '乡村振兴、数字乡村、县域商业、数据要素四大国家战略',
        }}
      />
      <main>
        <Hero />
        <PolicyTimeline />
        <Doc414 />
        <FormulaIP />
      </main>
      <Footer />
    </div>
  );
}